import { getValueAtPath, isPlainObject } from "../../../../../utils";
import SuccessView from "../../../common/success";
import ViewFactory from "../../../helpers/viewfactory";
import InitView from "./init";
import EventLog from "../../../../../logger/events"



export default function view() {
    const $this = this;
    const { $charge, $inputs, DATA } = this;

    const resetView = () => $this.cancelOption();

    return (view = ViewFactory({
        NAME: 'ENAIRA_OTP_VIEW',
        inputs: ['phone', 'otp'],
        constants: { resetView },

        next() {
            const {
                charge: flw_reference = null
            } = isPlainObject($this.reference) ? $this.reference : {};

            const phone = getValueAtPath($inputs, '[phone].value');
            const otp = getValueAtPath($inputs, '[otp].value');
            const { PBFPubKey } = DATA;
            
            if (phone && otp) {
                const data = {
                    otp,
                    "is_enaira": 1,
                    "PBFPubKey": PBFPubKey,
                    "phonenumber": phone,
                    "transactionreference": flw_reference
                }

                EventLog.startEnairaTokenValidation()
            
                $charge.validate({
                    data,
                    onBegin() { $this.CAN_GO_BACK = false },
                    onValidateSuccessful() { SuccessView && SuccessView.activate.call($this) },
                    onComplete() { /* self.console.log({ ...$this }) */ }
                });
            }
        }
    }).call(this))

}